import React from 'react';
import { Section } from 'common';
import { isTruthyValue } from 'utils';

import { CapitalizedText } from './ListSection.styled';

export const ListSection = ({ title, items = [] }) => {
  if (!items || items.length === 0) return null;

  return (
    <Section title={title}>
      <ul>
        {items.map(
          item =>
            isTruthyValue(item) && (
              <li key={item}>
                <CapitalizedText variant="body1">{item}</CapitalizedText>
              </li>
            )
        )}
      </ul>
    </Section>
  );
};
